import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica, authLink } from 'app/utils/boolean-input';

@Component({
  selector: 'app-logo-comune',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './logo-comune.component.html',
})
export class LogoComuneComponent {

    ckeckModifica(){
        return checkModifica()
    }


    authLink(url: string){
        return authLink(url)
    }

}
